var map = {
	"./betting_icon.embedded.svg": 1303,
	"./boxing_icon.embedded.svg": 1304,
	"./champions_league.embedded.svg": 1305,
	"./conmebol_icon.embedded.svg": 1306,
	"./csgo_icon.embedded.svg": 1307,
	"./dfs_icon.embedded.svg": 1308,
	"./dota2_icon.embedded.svg": 1309,
	"./dr_pepper.embedded.svg": 1310,
	"./dreamhack_icon.embedded.svg": 1311,
	"./esl_icon.embedded.svg": 1312,
	"./fifa.embedded.svg": 1313,
	"./fnatic_icon.embedded.svg": 1314,
	"./fortnite.embedded.svg": 1315,
	"./i_league_icon.embedded.svg": 1316,
	"./league-of-legends.embedded.svg": 1317,
	"./logo-12up.embedded.svg": 542,
	"./logo-90min.embedded.svg": 543,
	"./logo-dbltap.embedded.svg": 544,
	"./logo-ei.embedded.svg": 545,
	"./logo-floor8.embedded.svg": 546,
	"./logo-ftb90.embedded.svg": 547,
	"./logo-german_site.embedded.svg": 548,
	"./logo-ht_media.embedded.svg": 549,
	"./logo-pluralist.embedded.svg": 550,
	"./logo-theduel-mobile.embedded.svg": 551,
	"./logo-theduel.embedded.svg": 552,
	"./lol_icon.embedded.svg": 1318,
	"./mdl_icon.embedded.svg": 1319,
	"./melee_icon.embedded.svg": 1320,
	"./mlb_icon.embedded.svg": 1321,
	"./mls_icon.embedded.svg": 1322,
	"./mma_icon.embedded.svg": 1323,
	"./nba_icon.embedded.svg": 1324,
	"./ncaa-basketball_icon.embedded.svg": 1325,
	"./ncaa-football_icon.embedded.svg": 1326,
	"./nfl_icon.embedded.svg": 1327,
	"./nhl_icon.embedded.svg": 1328,
	"./overwatch.embedded.svg": 1329,
	"./overwatch_icon.embedded.svg": 1330,
	"./powered-by-ei.embedded.svg": 553,
	"./powered-by-german_site.embedded.svg": 554,
	"./powered-by-ht_media.embedded.svg": 555,
	"./pubg.embedded.svg": 1331,
	"./smash4_icon.embedded.svg": 1332,
	"./streetfighter_icon.embedded.svg": 1333,
	"./suzuki_cup.embedded.svg": 1334,
	"./theduel-nav.embedded.svg": 1335,
	"./theduel_menu_icon.embedded.svg": 1336,
	"./trending-games.embedded.svg": 1337,
	"./women-football.embedded.svg": 1338,
	"./world-cup.embedded.svg": 1339,
	"./yousport_icon.embedded.svg": 1340
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1352;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/.*\.embedded\.svg$
// module id = 1352
// module chunks = 37